import React from 'react';
import MessageSkeleton from './MessageSkeleton';

function MessagesSkeleton({ count = 6 }) {
  const generateSkeletonMessages = () => {
    const messages = [];
    for (let i = 0; i < count; i++) {
      const isSender = Math.random() > 0.5;
      const variant = Math.random() > 0.7 ? 'media' : 'text';
      messages.push(
        <MessageSkeleton 
          key={i} 
          isSender={isSender} 
          variant={variant}
        />
      );
    }
    return messages;
  };

  return (
    <>
      {generateSkeletonMessages()}
    </>
  );
}

export default MessagesSkeleton; 